import { render, staticRenderFns } from "./PurchaserForm.vue?vue&type=template&id=79c7f51e"
import script from "./PurchaserForm.vue?vue&type=script&lang=js"
export * from "./PurchaserForm.vue?vue&type=script&lang=js"
import style0 from "./PurchaserForm.vue?vue&type=style&index=0&id=79c7f51e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports